<template>
    <div class="main-container">
        <ExpandedLayout v-if="valid">
            <template #content>
                <router-view
                  :webmail_view="webmail_view"
                />
            </template>
        </ExpandedLayout>
    </div>
</template>

<script setup>
  import {onBeforeMount, ref}  from 'vue';
  import {useRouter, useRoute} from 'vue-router';
  import DomController         from '@/js/Webmail/DomController';
  import PopupController       from '@/js/Webmail/PopupController';
  import ExpandedLayout        from '../Layouts/ExpandedLayout.vue';

  const router = useRouter();
  const route  = useRoute();
  const valid  = ref(PopupController.isValidPopup());

  onBeforeMount(() => {
    if (valid.value === false) {
      router.push('/');
      return;
    }

    DomController.setBodyClass('body-popup');
  })

  const routeTo = (path, params) => {
    path = '/p' + path;

    if (params) {
      path += '?' + new URLSearchParams(params).toString();
    }
    else if (route.query) {
      path += '?' + new URLSearchParams(route.query).toString();
    }

    router.push(path);
  }

  const routeBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push({name: 'messages'});
    }
  }

  const webmail_view = {
    routeTo  : routeTo,
    routeBack: routeBack,
  };
</script>
